import { PERMISSIONS } from './permissions'

export const MANAGEMENT_TABS = [
  { label: 'General Settings', to: 'settings', permission: PERMISSIONS.GENERAL_SETTINGS },
  { label: 'Workers', to: 'workers', permission: PERMISSIONS.WORKERS },
  { label: 'Farming Block', to: 'farming-block', permission: PERMISSIONS.FARMING_BLOCK },
  { label: 'Activities', to: 'activities', permission: PERMISSIONS.ACTIVITIES },
  { label: 'Devices', to: 'devices', permission: PERMISSIONS.DEVICES },
  { label: 'Workday', to: 'workday', permission: PERMISSIONS.WORKDAY },
  { label: 'Data Edit', to: 'data-edit', permission: PERMISSIONS.DATA_EDIT },
  { label: 'Stickers', to: 'stickers', permission: PERMISSIONS.STICKERS },
  { label: 'Users Permissions', to: 'users', permission: PERMISSIONS.USERS }
]

export const DASHBOARD_TABS = [
  { label: 'Last Working Day Summary', to: 'last-working-day-summary', permission: PERMISSIONS.LAST_WORKING_DAY_SUMMARY },
  { label: 'Daily Pick Summary', to: 'daily-pick-summary', permission: PERMISSIONS.DAILY_PICK_SUMMARY },
  { label: 'Daily Agro Summary', to: 'daily-agro-summary', permission: PERMISSIONS.DAILY_AGRO_SUMMARY },
  { label: 'Daily Packing Summary', to: 'daily-packing-summary', permission: PERMISSIONS.DAILY_PACKING_SUMMARY },
  // { label: 'Weekly Pick Summary', to: 'weekly-pick-summary', permission: PERMISSIONS.WEEKLY_PICK_SUMMARY },
  // { label: 'Weekly Agro Summary', to: 'weekly-agro-summary', permission: PERMISSIONS.WEEKLY_AGRO_SUMMARY },
  { label: 'LEAM', to: 'leam', permission: PERMISSIONS.LEAM }
]
